// extracted by mini-css-extract-plugin
export var container = "_5j-0";
export var icon = "_5j-1";
export var text = "_5j-2";